import { render, staticRenderFns } from "./chuangjian.vue?vue&type=template&id=d85bfba0&scoped=true"
import script from "./chuangjian.vue?vue&type=script&lang=js"
export * from "./chuangjian.vue?vue&type=script&lang=js"
import style0 from "./chuangjian.vue?vue&type=style&index=0&id=d85bfba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85bfba0",
  null
  
)

export default component.exports